import { Injectable } from '@angular/core';
import { BehaviorSubject, catchError, finalize, tap, throwError } from 'rxjs';
import { DataCoreService, DlistDto, environment as env, GetDlist_Request, GetDlist_Response } from '@dabnet-kamu/libs/ui';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class LogFormIslemService {
  private _gridControlsLogList: BehaviorSubject<DlistDto | null> = new BehaviorSubject(null);
  public gridControlsLogList$ = this._gridControlsLogList.asObservable();

  constructor(private dataCoreService: DataCoreService, private _httpClient: HttpClient) {}

  getFormIslemLogDlist(dListCode: string) {
    // gridControlsLogList$ kok (root) singleton - bu servis yasadigi surece hep ayni kaliyor.
    // Deger zaten yuklendiyse tekrar cekmiyoruz; aksi halde component her acildiginda
    // (ör. popup her acilisinda) yeni bir istek atilip mevcut degerin ustune yenisi
    // basiliyor, bu da "once eski deger sonra yeni deger" seklinde cifte render'a yol aciyordu.
    if (this._gridControlsLogList.value) {
      return;
    }
    const request = new GetDlist_Request({
      dListCode: dListCode
    });
    this._httpClient.post<GetDlist_Response>(`${env.ortakService}/System/GetDList`, request).pipe(
      tap(response => {
        this._gridControlsLogList.next(response.dListMetadata);
      }),
      catchError(err => throwError(err)),
      finalize(() => {})
    ).subscribe();
  }

  getFormIslemLogData(formCode: string) {
    // FormAd, filtreleme için değil - her istekte sabit kalan bir querystring parametresi
    // olarak entity adına ekleniyor (bkz. irs-tahakkuk-giris-form.service.ts / hkp-tahakkuk-form.service.ts
    // 'stringQuery' deseni). Grid'in kendi filter/arama satırı bu parametreden bağımsız,
    // normal şekilde çalışmaya devam eder.
    // formCode çağırana göre tam route path (ör. '/IKA/IkaPersonelForm') veya çıplak form
    // kodu olabiliyor (bkz. list-footer.component.ts:getFormName). Loglar backend'de çıplak
    // koda göre tutulduğundan burada da aynı şekilde son '/' sonrası alınıyor; aksi halde
    // tam path ile sorgu boş sonuç dönüyordu.
    const bareFormCode = formCode.slice(formCode.lastIndexOf('/') + 1);
    const stringQuery = '?' + new URLSearchParams({ FormAd: bareFormCode }).toString();
    const dataSource = this.dataCoreService.getOData('vLogFormIslem' + stringQuery);
    dataSource.pageSize(100);
    return dataSource;
  }
}
